import { Injectable } from '@angular/core';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';
import { Question, FilterQuestion } from 'app/models/dto/question.model';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(private http: ApiHttpClient) { }

  getQuestions(): Observable<FilterQuestion[]> {
    return this.http.get<FilterQuestion[]>('/matching/questions/');
  }

  getQuestionRequirements(loanProductId: number) {
    return this.http.get(`/matching/loan-product/${loanProductId}/questions`);
  }

  getAnsweredQuestions(borrowerId: number) {
    return this.http.get(`/matching/questions/${borrowerId}/answered`);
  }

  getDocumentQuestions(borrowerId: number): Observable<BorrowerValue[]> {
    return this.http.get<BorrowerValue[]>(`/matching/questions/${borrowerId}/documents`);
  }

  getInformationalQuestionsforBorrower(borrowerId: number): Observable<BorrowerValue[]> {
    return this.http.get<BorrowerValue[]>(`/matching/questions/${borrowerId}/informational`);
  }

  getQuestionsforBorrower(borrowerId: number): Observable<BorrowerValue[]> {
    return this.http.get<BorrowerValue[]>(`/matching/questions/${borrowerId}`);
  }

  updateAnswers(borrowerId: number, savefields: BorrowerValue[]): Observable<BorrowerValue[]>  {
    return this.http.put<BorrowerValue[]>(`/matching/questions/${borrowerId}`, savefields);
  }
}
